import { useLayoutEffect, useState } from "react";
import { Router, BrowserRouterProps } from "react-router-dom";
import { createBrowserHistory, BrowserHistory } from "history";

export const history = createBrowserHistory();

interface Props extends BrowserRouterProps {
  history: BrowserHistory;
}
export const BrowserRouter = ({ history, ...props }: Props) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};